import moment from "moment";

export default class ItemFiltrosOrdenDeTrabajo {
    FiltroTexto: string;
    Estado: number;
    FechaDesde: string;
    FechaHasta: string;
    TiposTrabajos: string;
    Operarios: string;
    SoloNoLeidos: boolean;

    constructor() {
        this.FiltroTexto = "";
        this.Estado = 0;
        this.FechaDesde = `01/01/${moment().year() - 30}`;
        this.FechaHasta = `31/12/${moment().year() + 1}`;
        this.TiposTrabajos = "Todos";
        this.Operarios = "Todos";
        this.SoloNoLeidos = false;
    };
};
